<template>
  <div class="row">
    <div class="col-lg-8 offset-lg-2 col-md-8 offset-md-2 col-sm-12">
      <ul class="list-group">
        <li v-for="(position, index) in positions" @click="$emit('position-selected', index)" class="list-group-item d-flex justify-content-between align-items-center list-group-item-action interactive" >
          {{ position.name }}
          <!--<span class="badge badge-primary badge-pill"><i class="fa fa-star" aria-hidden="true"></i></span>-->
          <span class="badge badge-dark badge-pill">{{position.classification}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    export default {
      name: "app-positions-list",
      props: {
        positions: { type: Array, requite: true }
      }
    }
</script>

<style scoped>
  .interactive {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/app-positions-list.vue